import { setLocaleDateString } from './tools';

export const account_sms_default = `[{학원명} 교육비 안내]\r\n\r\n■ 성명 : {학생명}\r\n■ 청구내용 : {청구내용}\r\n■ 청구일자 : {청구일자}\r\n■ 청구금액 : {청구금액} 원\r\n\r\n변함없는 사랑과 관심을 보내주셔서 감사드립니다.\r\n더욱더 밝은 교육을 위해 힘쓰겠습니다♥\r\n\r\n※ 수납 안내 메시지는 (휴일 포함하여) 자동 발송되오니, 양해 부탁드립니다.\r\n\r\n→ 학원비 결제 : {결제링크}`;

export const makeAccountAlimContents = (cname: string) => {
  const today = new Date();
  const sevenDaysLater = new Date(today.setDate(today.getDate() + 6));

  return [
    `[${cname} 교육비 안내]\r\n`,
    '\r\n■ 성명 : 홍길동',
    '\r\n■ 청구내용 : 8월 분',
    `\r\n■ 납부기한 : ~${setLocaleDateString(sevenDaysLater, '. ')}`,
    '\r\n■ 청구금액 : 250,000원',
    '\r\n\r\n변함없는 사랑과 관심을 보내주시는 학부모님께 감사드립니다. 더욱더 나은 교육을 위해 힘쓰겠습니다 ♥',
    '\r\n\r\n※ 수납안내 메시지는 (휴일 포함) 자동 발송되니 양해 부탁드립니다 :)',
    '',
  ];
};

export const makeAccountAlimCostdayContents = (cname: string) => {
  return [
    `[${cname} 교육비 안내]\r\n`,
    '\r\n■ 성명 : 홍길동',
    '\r\n■ 청구내용 : 8월 분',
    `\r\n■ 청구일자 : ${setLocaleDateString(null, '. ')}`,
    '\r\n■ 청구금액 : 250,000원',
    '\r\n\r\n변함없는 사랑과 관심을 보내주시는 학부모님께 감사드립니다. 더욱더 나은 교육을 위해 힘쓰겠습니다 ♥',
    '\r\n\r\n※ 수납안내 메시지는 (휴일 포함) 자동 발송되니 양해 부탁드립니다 :)',
    '',
  ];
};
